import { Component, ComponentFactoryResolver, Inject, Input, OnInit, Output, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { EventEmitter } from 'events';
import { ModalHolderDirective } from '../../directives/modal-holder.directive';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GlobalService } from '../../services/global';
import { ComponentFactoryService } from '../../services/ComponentFactoryService';
import { AddfileComponent } from '../popups/addfile/addfile.component';
import { InfoCenterFile } from '../../models/InfoCenterFile';
import { ForgotPasswordComponent } from '../popups/forgot-password/forgot-password.component';
import { TermsandconditionsComponent } from '../popups/termsandconditions/termsandconditions.component';
import { RMA } from '../../models/RMA';
import { RmaSummaryComponent } from '../popups/rma-summary/rma-summary.component';
import { OrderSummaryComponent } from '../popups/order-summary/order-summary.component';
import { RmaRespondComponent } from '../popups/rma-respond/rma-respond.component';
import { RMAResponse } from '../../models/RMAResponse';
import { MessagesComponent } from '../popups/messages/messages.component';
import { NewsItemModalComponent } from '../popups/news-item/news-item.component';
import { NewsItem } from '../../models/NewsItem';
import { ItemSummaryComponent } from '../popups/item-summary/item-summary.component';
import { EditCategoryComponent } from '../popups/edit-category/edit-category.component';
import { Category } from '../../models/Category';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.css']
})
export class ModalComponent implements OnInit {
  @ViewChild(ModalHolderDirective, { static: true }) dynamicDirective: ModalHolderDirective;
  @ViewChild(TemplateRef) template;
  @Output() CloseEventEmitter: EventEmitter = new EventEmitter();
  @Output() ActionEventEmitter: EventEmitter = new EventEmitter();
  @Output() DisableTabsEmitter: EventEmitter = new EventEmitter();
  @Input() TempData: any;

  ActionButtonDisabled: boolean;
  CloseButtonDisabled: boolean;
  closeHidden: boolean;
  acceptHidden: boolean;

  private GetDataMethod: Function;
  private ValidateMethod: Function;

  AddNewFileComp: AddfileComponent;
  ForgotPasswordComp: ForgotPasswordComponent;
  TermsConditionsComp: TermsandconditionsComponent;
  RMASummaryComp: RmaSummaryComponent;
  OrderSummaryComp: OrderSummaryComponent;
  RMARespondComp: RmaRespondComponent;
  MessagesComp: MessagesComponent;
  NewsItemComp: NewsItemModalComponent;
  ItemSummaryComp: ItemSummaryComponent;
  EditCategoryComp: EditCategoryComponent;

  constructor(public dialogRef: MatDialogRef<ModalComponent>, @Inject(MAT_DIALOG_DATA) private modalData: any, public matDialog: MatDialog, public compFactory: ComponentFactoryResolver, public viewContainerRef: ViewContainerRef, private global: GlobalService, private compFactoryService: ComponentFactoryService) { }

  ngOnInit(): void {
    this.ActionButtonDisabled = false;
    this.CloseButtonDisabled = false;
    this.acceptHidden = false;
    this.closeHidden = false;

    if (this.modalData != null) {
      debugger;
      switch (true) {        
        case this.modalData instanceof InfoCenterFile:
          
          this.LoadAddInfoCenterFile();
          break;
        case this.modalData instanceof RMA:
          this.LoadRMA();
          break;
        default:
          if (this.modalData.type == "forgotpassword") {
            this.loadForgotPassword();
          }
          else if (this.modalData.type == "termsandconditions") {
            this.loadTermsAndConditions();
          }
          else if (this.modalData.type == "RMA") {
            this.LoadRMA();
          }
          else if (this.modalData.type == "OrderDetail") {
            this.LoadOrderDetails();
          }
          else if (this.modalData.type == "RMAResponse") {
            this.LoadRMAResponse();
          }
          else if (this.modalData.type == "Messages") {
            this.LoadCPQMessages();
          }
          else if (this.modalData.type == "NewsItem") {
            this.LoadNewsItem();
          }
          else if (this.modalData.type == "itemsummary") {
            this.LoadItemSummary();
          }
          else if (this.modalData.type == "category") {
            this.LoadCategory();
          }
          else if (this.modalData.type == "addinfocenterfile") {
            this.LoadAddInfoCenterFile();
          }
          else if (this.modalData.type == "editinfocenterfile") {
            this.LoadEditInfoCenterFile();
          }
      }
    }
  }

  show(compToOpen: any, dialogConfig: MatDialogConfig) {
    this.matDialog.open(compToOpen, dialogConfig)
  }


  actionMethod() {
    if (!this.ActionButtonDisabled) {
      var valid = false;
      if (this.ValidateMethod) {
        valid = this.ValidateMethod();
      }
      else {
        valid = true;
      }

      if (valid) {
        var retProfile = this.GetDataMethod();
        this.ActionEventEmitter.emit("actionEvent", retProfile);//this.GetDataMethod());
        this.destroyComp();
      }
    }
  }

  closeMethod() {
    this.CloseEventEmitter.emit("closeEvent");
    //this.dialogRef.close()
    this.destroyComp();
  }

  destroyComp() {
    this.compFactoryService.destroyComponent();
  }

  clearDisabledButtons() {
    this.ActionButtonDisabled = false;
    this.CloseButtonDisabled = false;
  }

  disableActionButton() {
    this.ActionButtonDisabled = true;
  }
  disabledCloseButton() {
    this.CloseButtonDisabled = true;
  }

  LoadAddInfoCenterFile() {
    let viewContainerRef = this.dynamicDirective.viewContaineRef;
    let componentRef = this.compFactoryService.createComponent(AddfileComponent, viewContainerRef);

    this.AddNewFileComp = componentRef.instance;
    this.AddNewFileComp.Categories = this.modalData.cats;
    
    this.AddNewFileComp.CreateNewFile(this.modalData.object);
    this.GetDataMethod = function (): InfoCenterFile {
      return this.AddNewFileComp.GetFile();
    };
  }

  LoadEditInfoCenterFile() {
    let viewContainerRef = this.dynamicDirective.viewContaineRef;
    let componentRef = this.compFactoryService.createComponent(AddfileComponent, viewContainerRef);

    this.AddNewFileComp = componentRef.instance;
    this.AddNewFileComp.Categories = this.modalData.cats;
    this.AddNewFileComp.SetEditFile(this.modalData.object);
    this.GetDataMethod = function (): InfoCenterFile {
      return this.AddNewFileComp.GetFile();
    };
  }

  LoadRMA() {
    let viewContainerRef = this.dynamicDirective.viewContaineRef;
    let componentRef = this.compFactoryService.createComponent(RmaSummaryComponent, viewContainerRef);
    
    this.RMASummaryComp = componentRef.instance;
    this.RMASummaryComp.rma = this.modalData.object.rma;
    this.RMASummaryComp.rmaItem = this.modalData.object.rmaItem;
    //this.RMASummaryComp.SetRMA(this.modalData.object.rma, this.modalData.object.rmaItem);
    this.RMASummaryComp.CloseEventEmitter.addListener("close", event => {
      this.closeMethod();
    });
    this.acceptHidden = true;
    this.GetDataMethod = function (): void { };
  }

  LoadOrderDetails() {
    let viewContainerRef = this.dynamicDirective.viewContaineRef;
    let componentRef = this.compFactoryService.createComponent(OrderSummaryComponent, viewContainerRef);
    
    this.OrderSummaryComp = componentRef.instance;
    this.OrderSummaryComp.detail = this.modalData.detail;
    this.OrderSummaryComp.order = this.modalData.order;
    this.OrderSummaryComp.SetupShipmentLinks();
    this.acceptHidden = true;
    this.GetDataMethod = function (): void { };
  }


  LoadNewsItem() {
    let viewContainerRef = this.dynamicDirective.viewContaineRef;
    let componentRef = this.compFactoryService.createComponent(NewsItemModalComponent, viewContainerRef);
    componentRef.instance.disableActionButton.subscribe(act => { this.disableActionButton(); });    
    componentRef.instance.enableButtons.subscribe(enable => { this.clearDisabledButtons(); });
    this.NewsItemComp = componentRef.instance;
    this.NewsItemComp.SetNewsItem(this.modalData.object);
    this.acceptHidden = false;
    this.ValidateMethod = function (): boolean { return this.NewsItemComp.Validate(); };
    this.GetDataMethod = function (): NewsItem {
      
        return this.NewsItemComp.GetNewsItem();
      
    };
  }

  LoadRMAResponse() {
    let viewContainerRef = this.dynamicDirective.viewContaineRef;
    let componentRef = this.compFactoryService.createComponent(RmaRespondComponent, viewContainerRef);

    this.RMARespondComp = componentRef.instance;
    this.RMARespondComp.RMA = this.modalData.object.rma;
    this.RMARespondComp.RMAItem = this.modalData.object.rmaItem;

    this.ValidateMethod = function (): boolean {
      return this.RMARespondComp.Validate();
    }


    this.GetDataMethod = function (): RMAResponse {
      return this.RMARespondComp.Response;
    }
    
  }

  loadForgotPassword() {
    let viewContainerRef = this.dynamicDirective.viewContaineRef;
    let componentRef = this.compFactoryService.createComponent(ForgotPasswordComponent, viewContainerRef);
    this.acceptHidden = true;
    this.closeHidden = true;
    this.ForgotPasswordComp = componentRef.instance;
    this.ForgotPasswordComp.ActionEventEmitter.subscribe(action => {
      //this.closeMethod();
    });
    this.ForgotPasswordComp.CloseEventEmitter.subscribe(close => {
      this.closeMethod();
    });
    this.GetDataMethod = function (): void { };
  }

  loadTermsAndConditions() {
    let viewContainerRef = this.dynamicDirective.viewContaineRef;
    let componentRef = this.compFactoryService.createComponent(TermsandconditionsComponent, viewContainerRef);

    this.TermsConditionsComp = componentRef.instance;
    this.acceptHidden = true;
    this.closeHidden = false;

    this.GetDataMethod = function (): void { };
  }

  LoadCPQMessages() {
    let viewContainerRef = this.dynamicDirective.viewContaineRef;
    let componentRef = this.compFactoryService.createComponent(MessagesComponent, viewContainerRef);

    this.MessagesComp = componentRef.instance;
    this.MessagesComp.Messages = this.modalData.object;
    this.acceptHidden = true;
    this.closeHidden = false;

    this.GetDataMethod = function (): void { };
  }

  LoadItemSummary() {
    let viewContainerRef = this.dynamicDirective.viewContaineRef;
    let componentRef = this.compFactoryService.createComponent(ItemSummaryComponent, viewContainerRef);

    this.ItemSummaryComp = componentRef.instance;
    this.ItemSummaryComp.Item = this.modalData.object;
    this.acceptHidden = true;
    this.closeHidden = false;

    this.GetDataMethod = function (): void { };
  }

  LoadCategory() {
    let viewContainerRef = this.dynamicDirective.viewContaineRef;
    let componentRef = this.compFactoryService.createComponent(EditCategoryComponent, viewContainerRef);

    this.EditCategoryComp = componentRef.instance;
    this.EditCategoryComp.CurrentCategory = this.modalData.object;
    this.EditCategoryComp.Categories = this.modalData.cats;
    this.acceptHidden = false;
    this.closeHidden = false;

    this.GetDataMethod = function (): Category {
      return this.EditCategoryComp.GetCategory();
    };
  }
}
